import type { EventType, HtmlType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'
import { Parameter } from '../../script/parameter.js'

@jsonClass('ChatAuditTrailBlock')
export class ChatAuditTrailBlock extends LeafBlock {
	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Entity instance / UUID',
		tooltip: () => ({
			text: 'The entity instance for which the audit trail should be displayed. Either this, a manually loaded list of messages or both can be used.',
		}),
		codeLanguage: 'ts',
		tsReturnType: () => 'Sys.Types.EntityInstanceOnDb | string',
		editorSize: 'singleline',
		isBinding: false,
	})
	entityInstanceExpression = new Expression('')

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'List of messages',
		codeLanguage: 'ts',
		tsReturnType: () => 'Sys.Types.ChatMessage[]',
		editorSize: 'singleline',
		isBinding: false,
	})
	messagesExpression = new Expression('')

	@jsonProperty(Boolean)
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 3,
		label: 'Allow sending new messages',
	})
	isAllowSending = true

	@jsonProperty(Boolean)
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 4,
		label: 'Send new message automatically',
		tooltip: () => ({
			text: 'If checked, new messages will be sent automatically (only supported for Entity instances).',
		}),
	})
	isSendAutomatically = true

	constructor(init: Partial<ChatAuditTrailBlock> = {}) {
		super()
		this.init(init)
	}

	get allowedEventTypes(): EventType[] {
		return [
			{
				name: 'send',
				parameters: [
					new Parameter({
						name: 'message',
						type: 'string',
						defaultExpression: '$event',
					}),
				],
			},
		]
	}

	producePreview(): HtmlType {
		return `CHAT`
	}

	getEditorCategory(): string {
		return 'Others'
	}
}
